//Need to pass a capability to open the alt products modal down a few layers to Suggested Products, so using Context.
import React from 'react';
import { ISalesCreditReasonInput, ISalesOrderInput } from '../../graphql/schema/p4types';
import { IUpdateTradeCounterSalesOrder } from '../../views/salesLedger/tradeCounter/TradeCounterForm';
import { IInvoiceLineItem } from '../../views/salesLedger/tradeCounter/SalesInvoiceCard';

const TradeCounterContext = React.createContext({} as Partial<ITradeCounterContext>);
export default TradeCounterContext;

export type ITradeCounterContext = {
  openStockAdjustment: (uuid: string) => void;
  openBatchAllocation: (rowIdx?: number) => void;
  salesOrder: ISalesOrderInput;
  updateSalesOrder: IUpdateTradeCounterSalesOrder;
};
